import Vue from 'vue'
import Router from 'vue-router'
import Newsfeed from '@/components/Functionals/Newsfeed'
import Report from '@/components/Shared/Report/'
import Audit from '@/components/Functionals/Audit'
import Profile from '@/components/Shared/Profile/'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Newsfeed',
      component: Newsfeed
    },
    {
      path: '/index.html',
      redirect: '/',
    },
    {
      path: '/mis-reportes',
      name: 'Mis Reportes',
      component: Report
    },
    {
      path: '/auditoria',
      name: 'Auditoría',
      component: Audit
    },
    {
      path: '/mi-perfil',
      name: 'Mi Perfil',
      component: Profile
    }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  Vue.prototype.$title.hasOwnProperty('show')
    ? Vue.prototype.$title.show(to.name)
    : false
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js